/* eslint-disable no-console */

import type { JSX } from 'react';
import { useEffect, useState } from 'react';

import { Text } from '@change/ds-core-ui';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { extractColors } from 'src/app/pages/petitionDetails/shared/utilities';
import type { ColorOption } from 'src/app/pages/petitionDetails/shared/utilities';

import { usePhoto } from '../hooks/photo';

import { MediaContainer } from './MediaSunrise';

export function HeadingContainer(): JSX.Element {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const photo = usePhoto();

	const defaultColor = {
		color: 'rgb(0,0,0)',
		rgba: 'rgba(0,0,0,1)',
		hex: '#0000',
		gradient:
			'linear-gradient(to_left,rgba(128,128,128,1)_0%,rgba(128,128,128,1)_79%,rgba(128,128,128,0.3)_95%,rgba(128,128,128,0)_100%)',
	};
	const imageUrl: string = petition.photo?.petitionMedium.url || '';
	const title: string = petition.displayTitle;

	const [selectedColor, setSelectedColor] = useState<ColorOption>(defaultColor);
	const gradientValue = selectedColor.gradient;
	const normalizedGradient = gradientValue.replace(/_/g, ' ');

	useEffect(() => {
		(async () => {
			try {
				const extractedColor = await extractColors(imageUrl);
				setSelectedColor(extractedColor);
			} catch (error) {
				console.error('Failed to extract colors', error);
			}
		})();
	}, [imageUrl]);

	return (
		<div
			data-experiment="petition-header-experiment"
			className="absolute max-h-[762px] w-full space-y-2 overflow-hidden rounded-xl bg-black md:aspect-[4/3] lg:aspect-[18/10]"
		>
			<div className="relative h-full w-full">
				<div className="mb-[100px] w-full">
					<div className="h-auto w-[1005px] [@media(max-width:1005px)]:w-full">
						{!!photo && <MediaContainer key={petition.id} photo={photo} />}
					</div>
					<div
						className="absolute bottom-0 right-0 top-0 z-[10] h-full w-[36%]"
						style={{ backgroundImage: normalizedGradient }}
					></div>
					<div className="absolute inset-[46%] bottom-0 left-0 right-0 z-[10] h-[92%] w-full bg-[linear-gradient(to_top,rgba(0,0,0,1)_48%,rgba(0,0,0,1)_70%,rgba(0,0,0,0.8)_75%,rgba(0,0,0,0)_87%)]" />
					<div className="absolute bottom-0 left-0 right-0 z-[11] px-4 py-4 sm:px-8 sm:py-[40px]">
						<div className="space-y-2">
							<div className="mb-[10px] h-[12px] w-[71.2px] bg-[#E5231E]"></div>
							<Text
								data-qa="petition-title"
								variant="heading"
								as="h2"
								size="x-large"
								className="max-w-[70%] text-balance text-xl font-bold leading-tight text-white sm:text-2xl md:max-w-[65%] lg:text-3xl"
							>
								{title}
							</Text>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
